import React from "react";
import InfoSection from "../common/InfoSection";
import FeaturesGrid from "../common/FeatureGrid";
import { features } from "../../constants/data";
import keyFeaturesImg from "../../assets/images/keyFeatures.svg";

function KeyFeatures() {
  return (
    <div className="max-w-1200 mx-auto w-full">
      <div className="px-4 sm:px-6 lg:px-0">
        <div className="flex flex-col gap-6">
          <InfoSection
            title="WHY RegTechFlow?"
            subtitle="Key Features"
            description="RegTechFlow comes equipped with innovative features that make managing your corporate, compliance, and license needs easier than ever:"
            additionalText=""
            // buttonText="Request a Demo"
            width="max-w-3xl"
            disable={true}
          />
          <FeaturesGrid imageUrl={keyFeaturesImg} features={features} imageOrder="order-1" featureOrder="order-2" />
        </div>
      </div>
    </div>
  );
}

export default KeyFeatures;
